module.exports = __webpack_public_path__ + "img/course_006.7e38e6e.png";